import { render, staticRenderFns } from "./CardReading.vue?vue&type=template&id=b057fd24&"
import script from "./CardReading.vue?vue&type=script&lang=js&"
export * from "./CardReading.vue?vue&type=script&lang=js&"
import style0 from "./CardReading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports